import React from "react";
import Chip from "@material-ui/core/Chip";

interface IManualStatusField {
  label?: string;
  value: string;
}

export const translateStatus = (status: string): string => {
  if (status) {
    return status.toUpperCase();
  }
  // make capital to all status
};

const getColor = (text: string): string => {
  if (text) {
    switch (text) {
      case "open":
        return "#4caf50";

      case "closed":
        return "#f44336";

      default:
        return "#9e9e9e";
    }
  }
};

const ManualStatusField = ({ label, value }: IManualStatusField) => {
  const translated = translateStatus(value);
  const color = getColor(value);

  return (
    <div>
      <Chip
        label={translated}
        style={{ backgroundColor: `${color}`, color: "#FFF" }}
      />
    </div>
  );
};

export default ManualStatusField;
